import { Alert } from "@xola/ui-kit";
import React from "react";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const PastBookingAlert = React.memo(() => {
    const isPastDateBooking = useCreatePurchaseStore((state) => state.isPastDateBooking());

    if (isPastDateBooking) {
        return <Alert color="danger">No notifications will be sent since this is a booking for past date</Alert>;
    }

    return null;
});

PastBookingAlert.displayName = "PastBookingAlert";
